import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavCardsInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || text_colorTextSecondary}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2 7.429V5.667C2 4.747 2.746 4 3.667 4h12.666C17.253 4 18 4.746 18 5.667v1.762m-16 0h16m-16 0v6.904C2 15.253 2.746 16 3.667 16h12.666c.92 0 1.667-.746 1.667-1.667V7.43m-7.14 5.042h3.94"
    />
  </svg>
)
export default SvgSidenavCardsInactive
